import { render, staticRenderFns } from "./WatchlistInnerTabNavigation.vue?vue&type=template&id=c7f83aea"
import script from "./WatchlistInnerTabNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistInnerTabNavigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WatchlistInnerTabNavigation.vue?vue&type=style&index=0&id=c7f83aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports